module.exports = __webpack_public_path__ + "img/tick.164579ba.svg";